"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackageType = exports.WeightUnitOfMeasure = exports.LengthUnitOfMeasure = exports.CancelReason = exports.ReasonForRefund = exports.RegionType = exports.ReturnShippingCostPayer = exports.ReturnMethod = exports.Metric = exports.FormatType = exports.Marketplace = exports.ContentLanguage = exports.Locale = exports.Condition = exports.CurrencyCode = exports.CountryCode = exports.RecipientAccountReferenceType = exports.PaymentMethodType = exports.PaymentsProgramStatus = exports.PaymentsProgramType = exports.ShippingCostType = exports.ShippingOptionType = exports.TimeDurationUnit = exports.StoreType = exports.ActivityOption = exports.RefundFeeType = exports.FilePurpose = exports.ReturnState = exports.ReturnCountFilter = exports.CategoryType = exports.Decision = exports.EscalateReason = exports.GetReturnFieldGroupEnum = exports.ReturnType = exports.RequestType = exports.ReturnReason = exports.ShippingCarrier = exports.InquiryStatusFilter = exports.CaseSearchFieldGroup = exports.CaseStatusFilter = exports.InquirySearchFieldGroup = exports.UserRoleFilter = void 0;
var UserRoleFilter;
(function (UserRoleFilter) {
    UserRoleFilter["BUYER"] = "BUYER";
    UserRoleFilter["SELLER"] = "SELLER";
})(UserRoleFilter = exports.UserRoleFilter || (exports.UserRoleFilter = {}));
var InquirySearchFieldGroup;
(function (InquirySearchFieldGroup) {
    InquirySearchFieldGroup["DEFAULT"] = "DEFAULT";
    InquirySearchFieldGroup["SUMMARY"] = "SUMMARY";
})(InquirySearchFieldGroup = exports.InquirySearchFieldGroup || (exports.InquirySearchFieldGroup = {}));
var CaseStatusFilter;
(function (CaseStatusFilter) {
    CaseStatusFilter["CLOSED"] = "CLOSED";
    CaseStatusFilter["CS_CLOSED"] = "CS_CLOSED";
    CaseStatusFilter["ON_HOLD"] = "ON_HOLD";
    CaseStatusFilter["OPEN"] = "OPEN";
    CaseStatusFilter["OTHER"] = "OTHER";
    CaseStatusFilter["REFUND_AGREED_BUT_FAILED"] = "REFUND_AGREED_BUT_FAILED";
    CaseStatusFilter["WAITING_CS"] = "WAITING_CS";
    CaseStatusFilter["WAITING_DELIVERY"] = "WAITING_DELIVERY";
})(CaseStatusFilter = exports.CaseStatusFilter || (exports.CaseStatusFilter = {}));
var CaseSearchFieldGroup;
(function (CaseSearchFieldGroup) {
    CaseSearchFieldGroup["DEFAULT"] = "DEFAULT";
    CaseSearchFieldGroup["SUMMARY"] = "SUMMARY";
})(CaseSearchFieldGroup = exports.CaseSearchFieldGroup || (exports.CaseSearchFieldGroup = {}));
var InquiryStatusFilter;
(function (InquiryStatusFilter) {
    InquiryStatusFilter["CLOSED"] = "CLOSED";
    InquiryStatusFilter["CLOSED_WITH_ESCALATION"] = "CLOSED_WITH_ESCALATION";
    InquiryStatusFilter["CS_CLOSED"] = "CS_CLOSED";
    InquiryStatusFilter["OPEN"] = "OPEN";
    InquiryStatusFilter["OTHER"] = "OTHER";
    InquiryStatusFilter["PENDING"] = "PENDING";
    InquiryStatusFilter["WAITING_BUYER_RESPONSE"] = "WAITING_BUYER_RESPONSE";
    InquiryStatusFilter["WAITING_SELLER_RESPONSE"] = "WAITING_SELLER_RESPONSE";
})(InquiryStatusFilter = exports.InquiryStatusFilter || (exports.InquiryStatusFilter = {}));
var ShippingCarrier;
(function (ShippingCarrier) {
    ShippingCarrier["AUSTRALIA_POST"] = "AUSTRALIA_POST";
    ShippingCarrier["BARTOLINI"] = "BARTOLINI";
    ShippingCarrier["CANADA_POST"] = "CANADA_POST";
    ShippingCarrier["COLISSIMO"] = "COLISSIMO";
    ShippingCarrier["COLLECT_PLUS"] = "COLLECT_PLUS";
    ShippingCarrier["CORREOS"] = "CORREOS";
    ShippingCarrier["DEUTSCHE_POST"] = "DEUTSCHE_POST";
    ShippingCarrier["DHL"] = "DHL";
    ShippingCarrier["FEDEX"] = "FEDEX";
    ShippingCarrier["HERMES"] = "HERMES";
    ShippingCarrier["LA_POSTE"] = "LA_POSTE";
    ShippingCarrier["MONDIAL_RELAY"] = "MONDIAL_RELAY";
    ShippingCarrier["MRW"] = "MRW";
    ShippingCarrier["NEXIVE"] = "NEXIVE";
    ShippingCarrier["OTHER"] = "OTHER";
    ShippingCarrier["PARCEL_FORCE"] = "PARCEL_FORCE";
    ShippingCarrier["POSTE"] = "POSTE";
    ShippingCarrier["ROYAL_MAIL"] = "ROYAL_MAIL";
    ShippingCarrier["SEUR"] = "SEUR";
    ShippingCarrier["UNKNOWN"] = "UNKNOWN";
    ShippingCarrier["UPS"] = "UPS";
    ShippingCarrier["USPS"] = "USPS";
})(ShippingCarrier = exports.ShippingCarrier || (exports.ShippingCarrier = {}));
var ReturnReason;
(function (ReturnReason) {
    ReturnReason["ARRIVED_DAMAGED"] = "ARRIVED_DAMAGED";
    ReturnReason["ARRIVED_LATE"] = "ARRIVED_LATE";
    ReturnReason["BUYER_CANCEL_ORDER"] = "BUYER_CANCEL_ORDER";
    ReturnReason["BUYER_NO_SHOW"] = "BUYER_NO_SHOW";
    ReturnReason["BUYER_NOT_SCHEDULED"] = "BUYER_NOT_SCHEDULED";
    ReturnReason["BUYER_REFUSED_TO_PICKUP"] = "BUYER_REFUSED_TO_PICKUP";
    ReturnReason["DEFECTIVE_ITEM"] = "DEFECTIVE_ITEM";
    ReturnReason["DIFFERENT_FROM_LISTING"] = "DIFFERENT_FROM_LISTING";
    ReturnReason["EXPIRED_ITEM"] = "EXPIRED_ITEM";
    ReturnReason["FAKE_OR_COUNTERFEIT"] = "FAKE_OR_COUNTERFEIT";
    ReturnReason["FOUND_BETTER_PRICE"] = "FOUND_BETTER_PRICE";
    ReturnReason["IN_STORE_RETURN"] = "IN_STORE_RETURN";
    ReturnReason["MISSING_PARTS"] = "MISSING_PARTS";
    ReturnReason["NO_LONGER_NEED_ITEM"] = "NO_LONGER_NEED_ITEM";
    ReturnReason["NO_REASON"] = "NO_REASON";
    ReturnReason["NOT_AS_DESCRIBED"] = "NOT_AS_DESCRIBED";
    ReturnReason["ORDERED_ACCIDENTALLY"] = "ORDERED_ACCIDENTALLY";
    ReturnReason["ORDERED_DIFFERENT_ITEM"] = "ORDERED_DIFFERENT_ITEM";
    ReturnReason["ORDERED_WRONG_ITEM"] = "ORDERED_WRONG_ITEM";
    ReturnReason["OTHER"] = "OTHER";
    ReturnReason["OUT_OF_STOCK"] = "OUT_OF_STOCK";
    ReturnReason["RETURNING_GIFT"] = "RETURNING_GIFT";
    ReturnReason["VALET_DELIVERY_ISSUES"] = "VALET_DELIVERY_ISSUES";
    ReturnReason["VALET_UNAVAILABLE"] = "VALET_UNAVAILABLE";
    ReturnReason["WRONG_SIZE"] = "WRONG_SIZE";
})(ReturnReason = exports.ReturnReason || (exports.ReturnReason = {}));
var RequestType;
(function (RequestType) {
    RequestType["CREATE"] = "CREATE";
    RequestType["REQUEST"] = "REQUEST";
    RequestType["UNKNOWN"] = "UNKNOWN";
})(RequestType = exports.RequestType || (exports.RequestType = {}));
var ReturnType;
(function (ReturnType) {
    ReturnType["EXCHANGE"] = "EXCHANGE";
    ReturnType["MONEY_BACK"] = "MONEY_BACK";
    ReturnType["REPLACEMENT"] = "REPLACEMENT";
    ReturnType["UNKNOWN"] = "UNKNOWN";
})(ReturnType = exports.ReturnType || (exports.ReturnType = {}));
var GetReturnFieldGroupEnum;
(function (GetReturnFieldGroupEnum) {
    GetReturnFieldGroupEnum["FULL"] = "FULL";
    GetReturnFieldGroupEnum["NONE"] = "NONE";
    GetReturnFieldGroupEnum["SUMMARY"] = "SUMMARY";
})(GetReturnFieldGroupEnum = exports.GetReturnFieldGroupEnum || (exports.GetReturnFieldGroupEnum = {}));
var EscalateReason;
(function (EscalateReason) {
    EscalateReason["BUYER_NORESPONSE"] = "BUYER_NORESPONSE";
    EscalateReason["BUYER_RETURNED_WRONG_ITEM"] = "BUYER_RETURNED_WRONG_ITEM";
    EscalateReason["DISAGREE_WITH_RETURN_REASON"] = "DISAGREE_WITH_RETURN_REASON";
    EscalateReason["ITEM_NOT_RECEIVED"] = "ITEM_NOT_RECEIVED";
    EscalateReason["ITEM_RECEIVED_IN_DIFFERENT_CONDITION"] = "ITEM_RECEIVED_IN_DIFFERENT_CONDITION";
    EscalateReason["NEW_ITEM_NOT_RECEIVED"] = "NEW_ITEM_NOT_RECEIVED";
    EscalateReason["NO_REFUND_FOR_RETURN_SHIPPING"] = "NO_REFUND_FOR_RETURN_SHIPPING";
    EscalateReason["NO_REFUND_RECEIVED"] = "NO_REFUND_RECEIVED";
    EscalateReason["OTHER"] = "OTHER";
    EscalateReason["RECEIVED_WRONG_ITEM"] = "RECEIVED_WRONG_ITEM";
    EscalateReason["SELLER_NO_RESPONSE"] = "SELLER_NO_RESPONSE";
    EscalateReason["TROUBLE_COMMUNICATION_WITH_BUYER"] = "TROUBLE_COMMUNICATION_WITH_BUYER";
    EscalateReason["TROUBLE_COMMUNICATION_WITH_SELLER"] = "TROUBLE_COMMUNICATION_WITH_SELLER";
})(EscalateReason = exports.EscalateReason || (exports.EscalateReason = {}));
var Decision;
(function (Decision) {
    Decision["ACCEPT_PARTIAL_REFUND"] = "ACCEPT_PARTIAL_REFUND";
    Decision["ACCEPT_REPLACEMENT_OFFER"] = "ACCEPT_REPLACEMENT_OFFER";
    Decision["APPROVE"] = "APPROVE";
    Decision["APPROVE_WITHOUT_EBAY_LABEL"] = "APPROVE_WITHOUT_EBAY_LABEL";
    Decision["DECLINE"] = "DECLINE";
    Decision["DECLINE_PARTIAL_REFUND"] = "DECLINE_PARTIAL_REFUND";
    Decision["DECLINE_REPLACEMENT_OFFER"] = "DECLINE_REPLACEMENT_OFFER";
    Decision["OFFER_PARTIAL_REFUND"] = "OFFER_PARTIAL_REFUND";
    Decision["OFFER_REPLACEMENT"] = "OFFER_REPLACEMENT";
    Decision["OFFER_RETURN"] = "OFFER_RETURN";
    Decision["OFFER_RETURN_WITHOUT_LABEL"] = "OFFER_RETURN_WITHOUT_LABEL";
    Decision["PROVIDE_RMA"] = "PROVIDE_RMA";
    Decision["UNKNOWN"] = "UNKNOWN";
})(Decision = exports.Decision || (exports.Decision = {}));
var CategoryType;
(function (CategoryType) {
    CategoryType["MOTORS_VEHICLES"] = "MOTORS_VEHICLES";
    CategoryType["ALL_EXCLUDING_MOTORS_VEHICLES"] = "ALL_EXCLUDING_MOTORS_VEHICLES";
})(CategoryType = exports.CategoryType || (exports.CategoryType = {}));
var ReturnCountFilter;
(function (ReturnCountFilter) {
    ReturnCountFilter["ALL_OPEN"] = "ALL_OPEN";
    ReturnCountFilter["ALL_OPEN_REPLACEMENT"] = "ALL_OPEN_REPLACEMENT";
    ReturnCountFilter["ALL_OPEN_RETURN"] = "ALL_OPEN_RETURN";
    ReturnCountFilter["CLOSED"] = "CLOSED";
    ReturnCountFilter["EBAY_PLUS"] = "EBAY_PLUS";
    ReturnCountFilter["ITEM_DELIVERED"] = "ITEM_DELIVERED";
    ReturnCountFilter["ITEM_SHIPPED"] = "ITEM_SHIPPED";
    ReturnCountFilter["RETURN_STARTED"] = "RETURN_STARTED";
    ReturnCountFilter["SELLER_ACTION_DUE"] = "SELLER_ACTION_DUE";
    ReturnCountFilter["SELLER_ACTION_OVERDUE"] = "SELLER_ACTION_OVERDUE";
    ReturnCountFilter["SELLER_NO_ACTION"] = "SELLER_NO_ACTION";
    ReturnCountFilter["UNKNOWN"] = "UNKNOWN";
})(ReturnCountFilter = exports.ReturnCountFilter || (exports.ReturnCountFilter = {}));
var ReturnState;
(function (ReturnState) {
    ReturnState["AUTO_REFUND_INITIATED"] = "AUTO_REFUND_INITIATED";
    ReturnState["CLOSED"] = "CLOSED";
    ReturnState["INITIAL"] = "INITIAL";
    ReturnState["ITEM_DELIVERED"] = "ITEM_DELIVERED";
    ReturnState["ITEM_KEPT"] = "ITEM_KEPT";
    ReturnState["ITEM_READY_TO_SHIP"] = "ITEM_READY_TO_SHIP";
    ReturnState["ITEM_SHIPPED"] = "ITEM_SHIPPED";
    ReturnState["LESS_THAN_A_FULL_REFUND_ISSUED"] = "LESS_THAN_A_FULL_REFUND_ISSUED";
    ReturnState["PARTIAL_REFUND_AS_PAYOUT_INITIATED"] = "PARTIAL_REFUND_AS_PAYOUT_INITIATED";
    ReturnState["PARTIAL_REFUND_DECLINED"] = "PARTIAL_REFUND_DECLINED";
    ReturnState["PARTIAL_REFUND_FAILED"] = "PARTIAL_REFUND_FAILED";
    ReturnState["PARTIAL_REFUND_INITIATED"] = "PARTIAL_REFUND_INITIATED";
    ReturnState["PARTIAL_REFUND_NON_PAYPAL_INITIATED"] = "PARTIAL_REFUND_NON_PAYPAL_INITIATED";
    ReturnState["PARTIAL_REFUND_REQUESTED"] = "PARTIAL_REFUND_REQUESTED";
    ReturnState["PARTIAL_REFUNDED"] = "PARTIAL_REFUNDED";
    ReturnState["PAYOUT_INITIATED"] = "PAYOUT_INITIATED";
    ReturnState["REFUND_AS_PAYOUT_INITIATED"] = "REFUND_AS_PAYOUT_INITIATED";
    ReturnState["REFUND_FAILED"] = "REFUND_FAILED";
    ReturnState["REFUND_INITIATED"] = "REFUND_INITIATED";
    ReturnState["REFUND_SENT_PENDING_CONFIRMATION"] = "REFUND_SENT_PENDING_CONFIRMATION";
    ReturnState["REFUND_TIMEOUT"] = "REFUND_TIMEOUT";
    ReturnState["REPLACED"] = "REPLACED";
    ReturnState["REPLACEMENT_CLOSED"] = "REPLACEMENT_CLOSED";
    ReturnState["REPLACEMENT_DELIVERED"] = "REPLACEMENT_DELIVERED";
    ReturnState["REPLACEMENT_LABEL_PENDING"] = "REPLACEMENT_LABEL_PENDING";
    ReturnState["REPLACEMENT_LABEL_PENDING_TIMEOUT"] = "REPLACEMENT_LABEL_PENDING_TIMEOUT";
    ReturnState["REPLACEMENT_LABEL_REQUESTED"] = "REPLACEMENT_LABEL_REQUESTED";
    ReturnState["REPLACEMENT_LABEL_REQUESTED_TIMEOUT"] = "REPLACEMENT_LABEL_REQUESTED_TIMEOUT";
    ReturnState["REPLACEMENT_OFFER_PENDING"] = "REPLACEMENT_OFFER_PENDING";
    ReturnState["REPLACEMENT_REQUEST_TIMEOUT"] = "REPLACEMENT_REQUEST_TIMEOUT";
    ReturnState["REPLACEMENT_REQUESTED"] = "REPLACEMENT_REQUESTED";
    ReturnState["REPLACEMENT_RMA_PENDING"] = "REPLACEMENT_RMA_PENDING";
    ReturnState["REPLACEMENT_SHIPPED"] = "REPLACEMENT_SHIPPED";
    ReturnState["REPLACEMENT_STARTED"] = "REPLACEMENT_STARTED";
    ReturnState["RETURN_LABEL_PENDING"] = "RETURN_LABEL_PENDING";
    ReturnState["RETURN_LABEL_PENDING_TIMEOUT"] = "RETURN_LABEL_PENDING_TIMEOUT";
    ReturnState["RETURN_LABEL_REQUESTED"] = "RETURN_LABEL_REQUESTED";
    ReturnState["RETURN_LABEL_REQUESTED_TIMEOUT"] = "RETURN_LABEL_REQUESTED_TIMEOUT";
    ReturnState["RETURN_REJECTED"] = "RETURN_REJECTED";
    ReturnState["RETURN_REQUEST_TIMEOUT"] = "RETURN_REQUEST_TIMEOUT";
    ReturnState["RETURN_REQUESTED"] = "RETURN_REQUESTED";
    ReturnState["RMA_PENDING"] = "RMA_PENDING";
    ReturnState["UNKNOWN"] = "UNKNOWN";
})(ReturnState = exports.ReturnState || (exports.ReturnState = {}));
var FilePurpose;
(function (FilePurpose) {
    FilePurpose["ITEM_RELATED"] = "ITEM_RELATED";
    FilePurpose["LABEL_RELATED"] = "LABEL_RELATED";
    FilePurpose["REFUND_RELATED"] = "REFUND_RELATED";
    FilePurpose["UNKNOWN"] = "UNKNOWN";
})(FilePurpose = exports.FilePurpose || (exports.FilePurpose = {}));
var RefundFeeType;
(function (RefundFeeType) {
    RefundFeeType["DOMESTIC_SHIPPING"] = "DOMESTIC_SHIPPING";
    RefundFeeType["IMPORT_CHARGE"] = "IMPORT_CHARGE";
    RefundFeeType["INTERNATIONAL_SHIPPING"] = "INTERNATIONAL_SHIPPING";
    RefundFeeType["ITEM_IMPORT_TAX"] = "ITEM_IMPORT_TAX";
    RefundFeeType["ITEM_TAX"] = "ITEM_TAX";
    RefundFeeType["ORDER_ADJUSTMENT"] = "ORDER_ADJUSTMENT";
    RefundFeeType["ORIGINAL_SHIPPING"] = "ORIGINAL_SHIPPING";
    RefundFeeType["OTHER"] = "OTHER";
    RefundFeeType["PURCHASE_PRICE"] = "PURCHASE_PRICE";
    RefundFeeType["REFUND_FROM_PAYPAL"] = "REFUND_FROM_PAYPAL";
    RefundFeeType["RETURN_SHIPPING"] = "RETURN_SHIPPING";
    RefundFeeType["SHIPPING_IMPORT_TAX"] = "SHIPPING_IMPORT_TAX";
    RefundFeeType["SHIPPING_TAX"] = "SHIPPING_TAX";
})(RefundFeeType = exports.RefundFeeType || (exports.RefundFeeType = {}));
var ActivityOption;
(function (ActivityOption) {
    ActivityOption["AUTO_APPROVE_REMORSE"] = "AUTO_APPROVE_REMORSE";
    ActivityOption["BUYER_ACCEPT_REPLACEMENT_OFFER"] = "BUYER_ACCEPT_REPLACEMENT_OFFER";
    ActivityOption["BUYER_ACCEPTS_NON_PAYPAL_PARTIAL_REFUND"] = "BUYER_ACCEPTS_NON_PAYPAL_PARTIAL_REFUND";
    ActivityOption["BUYER_ACCEPTS_PARTIAL_REFUND"] = "BUYER_ACCEPTS_PARTIAL_REFUND";
    ActivityOption["BUYER_CLOSE_RETURN"] = "BUYER_CLOSE_RETURN";
    ActivityOption["BUYER_CREATE_RETURN"] = "BUYER_CREATE_RETURN";
    ActivityOption["BUYER_DECLINE_PARTIAL_REFUND"] = "BUYER_DECLINE_PARTIAL_REFUND";
    ActivityOption["BUYER_DECLINE_REPLACEMENT_OFFER"] = "BUYER_DECLINE_REPLACEMENT_OFFER";
    ActivityOption["BUYER_ESCALATE"] = "BUYER_ESCALATE";
    ActivityOption["BUYER_MARK_AS_RECEIVED"] = "BUYER_MARK_AS_RECEIVED";
    ActivityOption["BUYER_MARK_REFUND_RECEIVED"] = "BUYER_MARK_REFUND_RECEIVED";
    ActivityOption["BUYER_MARK_RETURN_SHIPPED"] = "BUYER_MARK_RETURN_SHIPPED";
    ActivityOption["BUYER_PRINT_SHIPPING_LABEL"] = "BUYER_PRINT_SHIPPING_LABEL";
    ActivityOption["BUYER_PROVIDE_LABEL"] = "BUYER_PROVIDE_LABEL";
    ActivityOption["BUYER_PROVIDE_TRACKING_INFO"] = "BUYER_PROVIDE_TRACKING_INFO";
    ActivityOption["BUYER_SEND_MESSAGE"] = "BUYER_SEND_MESSAGE";
    ActivityOption["BUYER_UPDATE_TRACKING"] = "BUYER_UPDATE_TRACKING";
    ActivityOption["BUYER_VOID_LABEL"] = "BUYER_VOID_LABEL";
    ActivityOption["CHARGEBACK_OPEN"] = "CHARGEBACK_OPEN";
    ActivityOption["DELETE_FILE"] = "DELETE_FILE";
    ActivityOption["EMAIL_SHIPPING_LABEL"] = "EMAIL_SHIPPING_LABEL";
    ActivityOption["EXTERNAL_CLAIM_OPENED"] = "EXTERNAL_CLAIM_OPENED";
    ActivityOption["GENERAL_TIME_OUT"] = "GENERAL_TIME_OUT";
    ActivityOption["NOTIFIED_DELIVERED"] = "NOTIFIED_DELIVERED";
    ActivityOption["NOTIFIED_SHIPPED"] = "NOTIFIED_SHIPPED";
    ActivityOption["NOTIFY_REPLACEMENT_DELIVERED"] = "NOTIFY_REPLACEMENT_DELIVERED";
    ActivityOption["NOTIFY_REPLACEMENT_SHIPPED"] = "NOTIFY_REPLACEMENT_SHIPPED";
    ActivityOption["NOTIFY_UPDATE_REFUND_STATUS"] = "NOTIFY_UPDATE_REFUND_STATUS";
    ActivityOption["OTHER"] = "OTHER";
    ActivityOption["REMINDER_BUYER_TO_RESPOND_RE_OFFER"] = "REMINDER_BUYER_TO_RESPOND_RE_OFFER";
    ActivityOption["REMINDER_BUYER_TO_SHIP"] = "REMINDER_BUYER_TO_SHIP";
    ActivityOption["REMINDER_FOR_REFUND"] = "REMINDER_FOR_REFUND";
    ActivityOption["REMINDER_FOR_REFUND_NO_SHIPPING"] = "REMINDER_FOR_REFUND_NO_SHIPPING";
    ActivityOption["REMINDER_FOR_RMA"] = "REMINDER_FOR_RMA";
    ActivityOption["REMINDER_FOR_SHIPPING"] = "REMINDER_FOR_SHIPPING";
    ActivityOption["REMINDER_SELLER_TO_RESPOND"] = "REMINDER_SELLER_TO_RESPOND";
    ActivityOption["REMINDER_SELLER_TO_SHIP"] = "REMINDER_SELLER_TO_SHIP";
    ActivityOption["SELLER_APPROVE_REQUEST"] = "SELLER_APPROVE_REQUEST";
    ActivityOption["SELLER_DECLINE_REQUEST"] = "SELLER_DECLINE_REQUEST";
    ActivityOption["SELLER_ESCALATE"] = "SELLER_ESCALATE";
    ActivityOption["SELLER_ISSUE_REFUND"] = "SELLER_ISSUE_REFUND";
    ActivityOption["SELLER_ISSUE_STORE_CREDIT_REFUND"] = "SELLER_ISSUE_STORE_CREDIT_REFUND";
    ActivityOption["SELLER_MARK_AS_RECEIVED"] = "SELLER_MARK_AS_RECEIVED";
    ActivityOption["SELLER_MARK_REFUND_SENT"] = "SELLER_MARK_REFUND_SENT";
    ActivityOption["SELLER_MARK_REPLACEMENT_SHIPPED"] = "SELLER_MARK_REPLACEMENT_SHIPPED";
    ActivityOption["SELLER_OFFER_PARTIAL_REFUND"] = "SELLER_OFFER_PARTIAL_REFUND";
    ActivityOption["SELLER_OFFER_REPLACEMENT"] = "SELLER_OFFER_REPLACEMENT";
    ActivityOption["SELLER_OFFER_RETURNS"] = "SELLER_OFFER_RETURNS";
    ActivityOption["SELLER_PRINT_SHIPPING_LABEL"] = "SELLER_PRINT_SHIPPING_LABEL";
    ActivityOption["SELLER_PROVIDE_LABEL"] = "SELLER_PROVIDE_LABEL";
    ActivityOption["SELLER_PROVIDE_RMA"] = "SELLER_PROVIDE_RMA";
    ActivityOption["SELLER_PROVIDE_TRACKING_INFO"] = "SELLER_PROVIDE_TRACKING_INFO";
    ActivityOption["SELLER_RETRY_REFUND"] = "SELLER_RETRY_REFUND";
    ActivityOption["SELLER_SEND_MESSAGE"] = "SELLER_SEND_MESSAGE";
    ActivityOption["SELLER_UPDATE_TRACKING"] = "SELLER_UPDATE_TRACKING";
    ActivityOption["SELLER_VOID_LABEL"] = "SELLER_VOID_LABEL";
    ActivityOption["SUBMIT_FILE"] = "SUBMIT_FILE";
    ActivityOption["SYSTEM_BUYER_PARTIAL_REFUND_AS_PAYOUT"] = "SYSTEM_BUYER_PARTIAL_REFUND_AS_PAYOUT";
    ActivityOption["SYSTEM_BUYER_REFUND_AS_PAYOUT"] = "SYSTEM_BUYER_REFUND_AS_PAYOUT";
    ActivityOption["SYSTEM_CLOSE_RETURN"] = "SYSTEM_CLOSE_RETURN";
    ActivityOption["SYSTEM_CREATE_RETURN"] = "SYSTEM_CREATE_RETURN";
    ActivityOption["SYSTEM_IMMEDIATE_REFUND"] = "SYSTEM_IMMEDIATE_REFUND";
    ActivityOption["TIME_OUT_AFTER_DECLINE"] = "TIME_OUT_AFTER_DECLINE";
    ActivityOption["TIME_OUT_AFTER_REFUNDED"] = "TIME_OUT_AFTER_REFUNDED";
    ActivityOption["TIME_OUT_AFTER_REFUNDED_AS_PAYOUT"] = "TIME_OUT_AFTER_REFUNDED_AS_PAYOUT";
    ActivityOption["TIME_OUT_AFTER_REPLACED"] = "TIME_OUT_AFTER_REPLACED";
    ActivityOption["TIME_OUT_FOR_AUTHORIZE"] = "TIME_OUT_FOR_AUTHORIZE";
    ActivityOption["TIME_OUT_FOR_AUTO_REFUND"] = "TIME_OUT_FOR_AUTO_REFUND";
    ActivityOption["TIME_OUT_FOR_BUYER_RECOUP"] = "TIME_OUT_FOR_BUYER_RECOUP";
    ActivityOption["TIME_OUT_FOR_DELIVERY"] = "TIME_OUT_FOR_DELIVERY";
    ActivityOption["TIME_OUT_FOR_ESCALATION"] = "TIME_OUT_FOR_ESCALATION";
    ActivityOption["TIME_OUT_FOR_ESCALATION_AFTER_SMIR"] = "TIME_OUT_FOR_ESCALATION_AFTER_SMIR";
    ActivityOption["TIME_OUT_FOR_ITEM_REPLACED"] = "TIME_OUT_FOR_ITEM_REPLACED";
    ActivityOption["TIME_OUT_FOR_MARK_REFUND_RECEIVED"] = "TIME_OUT_FOR_MARK_REFUND_RECEIVED";
    ActivityOption["TIME_OUT_FOR_MARK_REFUND_SENT"] = "TIME_OUT_FOR_MARK_REFUND_SENT";
    ActivityOption["TIME_OUT_FOR_MASS_PAYOUT"] = "TIME_OUT_FOR_MASS_PAYOUT";
    ActivityOption["TIME_OUT_FOR_PAYOUT"] = "TIME_OUT_FOR_PAYOUT";
    ActivityOption["TIME_OUT_FOR_PROVIDE_LABEL"] = "TIME_OUT_FOR_PROVIDE_LABEL";
    ActivityOption["TIME_OUT_FOR_REFUND"] = "TIME_OUT_FOR_REFUND";
    ActivityOption["TIME_OUT_FOR_REPLACEMENT_DELIVERED_ITEM_NOT_RETURNED"] = "TIME_OUT_FOR_REPLACEMENT_DELIVERED_ITEM_NOT_RETURNED";
    ActivityOption["TIME_OUT_FOR_REPLACEMENT_SHIPPED"] = "TIME_OUT_FOR_REPLACEMENT_SHIPPED";
    ActivityOption["TIME_OUT_FOR_RETURN_SHIPPING"] = "TIME_OUT_FOR_RETURN_SHIPPING";
    ActivityOption["TIME_OUT_FOR_RMA"] = "TIME_OUT_FOR_RMA";
    ActivityOption["TIME_OUT_FOR_SELLER_INVOICE"] = "TIME_OUT_FOR_SELLER_INVOICE";
    ActivityOption["TIME_OUT_FOR_SELLER_PAYOUT"] = "TIME_OUT_FOR_SELLER_PAYOUT";
    ActivityOption["TIME_OUT_FOR_SHIPMENT_TRACKING"] = "TIME_OUT_FOR_SHIPMENT_TRACKING";
    ActivityOption["TIME_OUT_FOR_SHIPPING"] = "TIME_OUT_FOR_SHIPPING";
    ActivityOption["TIME_OUT_FOR_SHIPPING_SYSTEM_CLOSE"] = "TIME_OUT_FOR_SHIPPING_SYSTEM_CLOSE";
})(ActivityOption = exports.ActivityOption || (exports.ActivityOption = {}));
var StoreType;
(function (StoreType) {
    StoreType["STORE"] = "STORE";
    StoreType["WAREHOUSE"] = "WAREHOUSE";
})(StoreType = exports.StoreType || (exports.StoreType = {}));
var TimeDurationUnit;
(function (TimeDurationUnit) {
    TimeDurationUnit["YEAR"] = "YEAR";
    TimeDurationUnit["MONTH"] = "MONTH";
    TimeDurationUnit["DAY"] = "DAY";
    TimeDurationUnit["HOUR"] = "HOUR";
    TimeDurationUnit["CALENDAR_DAY"] = "CALENDAR_DAY";
    TimeDurationUnit["BUSINESS_DAY"] = "BUSINESS_DAY";
    TimeDurationUnit["MINUTE"] = "MINUTE";
    TimeDurationUnit["SECOND"] = "SECOND";
    TimeDurationUnit["MILLISECOND"] = "MILLISECOND";
})(TimeDurationUnit = exports.TimeDurationUnit || (exports.TimeDurationUnit = {}));
var ShippingOptionType;
(function (ShippingOptionType) {
    ShippingOptionType["DOMESTIC"] = "DOMESTIC";
    ShippingOptionType["INTERNATIONAL"] = "INTERNATIONAL";
})(ShippingOptionType = exports.ShippingOptionType || (exports.ShippingOptionType = {}));
var ShippingCostType;
(function (ShippingCostType) {
    ShippingCostType["CALCULATED"] = "CALCULATED";
    ShippingCostType["FLAT_RATE"] = "FLAT_RATE";
    ShippingCostType["NOT_SPECIFIED"] = "NOT_SPECIFIED";
})(ShippingCostType = exports.ShippingCostType || (exports.ShippingCostType = {}));
var PaymentsProgramType;
(function (PaymentsProgramType) {
    PaymentsProgramType["EBAY_PAYMENTS"] = "EBAY_PAYMENTS";
})(PaymentsProgramType = exports.PaymentsProgramType || (exports.PaymentsProgramType = {}));
var PaymentsProgramStatus;
(function (PaymentsProgramStatus) {
    PaymentsProgramStatus["OPTED_IN"] = "OPTED_IN";
    PaymentsProgramStatus["NOT_OPTED_IN"] = "NOT_OPTED_IN";
})(PaymentsProgramStatus = exports.PaymentsProgramStatus || (exports.PaymentsProgramStatus = {}));
var PaymentMethodType;
(function (PaymentMethodType) {
    PaymentMethodType["CASH_IN_PERSON"] = "CASH_IN_PERSON";
    PaymentMethodType["CASH_ON_DELIVERY"] = "CASH_ON_DELIVERY";
    PaymentMethodType["CASH_ON_PICKUP"] = "CASH_ON_PICKUP";
    PaymentMethodType["CASHIER_CHECK"] = "CASHIER_CHECK";
    PaymentMethodType["CREDIT_CARD"] = "CREDIT_CARD";
    PaymentMethodType["ESCROW"] = "ESCROW";
    PaymentMethodType["INTEGRATED_MERCHANT_CREDIT_CARD"] = "INTEGRATED_MERCHANT_CREDIT_CARD";
    PaymentMethodType["LOAN_CHECK"] = "LOAN_CHECK";
    PaymentMethodType["MONEY_ORDER"] = "MONEY_ORDER";
    PaymentMethodType["PAISA_PAY"] = "PAISA_PAY";
    PaymentMethodType["PAISA_PAY_ESCROW"] = "PAISA_PAY_ESCROW";
    PaymentMethodType["PAISA_PAY_ESCROW_EMI"] = "PAISA_PAY_ESCROW_EMI";
    PaymentMethodType["PAYPAL"] = "PAYPAL";
    PaymentMethodType["PERSONAL_CHECK"] = "PERSONAL_CHECK";
    PaymentMethodType["OTHER"] = "OTHER";
})(PaymentMethodType = exports.PaymentMethodType || (exports.PaymentMethodType = {}));
var RecipientAccountReferenceType;
(function (RecipientAccountReferenceType) {
    RecipientAccountReferenceType["PAYPAL_EMAIL"] = "PAYPAL_EMAIL";
})(RecipientAccountReferenceType = exports.RecipientAccountReferenceType || (exports.RecipientAccountReferenceType = {}));
var CountryCode;
(function (CountryCode) {
    CountryCode["AD"] = "AD";
    CountryCode["AE"] = "AE";
    CountryCode["AF"] = "AF";
    CountryCode["AG"] = "AG";
    CountryCode["AI"] = "AI";
    CountryCode["AL"] = "AL";
    CountryCode["AM"] = "AM";
    CountryCode["AN"] = "AN";
    CountryCode["AO"] = "AO";
    CountryCode["AQ"] = "AQ";
    CountryCode["AR"] = "AR";
    CountryCode["AS"] = "AS";
    CountryCode["AT"] = "AT";
    CountryCode["AU"] = "AU";
    CountryCode["AW"] = "AW";
    CountryCode["AX"] = "AX";
    CountryCode["AZ"] = "AZ";
    CountryCode["BA"] = "BA";
    CountryCode["BB"] = "BB";
    CountryCode["BD"] = "BD";
    CountryCode["BE"] = "BE";
    CountryCode["BF"] = "BF";
    CountryCode["BG"] = "BG";
    CountryCode["BH"] = "BH";
    CountryCode["BI"] = "BI";
    CountryCode["BJ"] = "BJ";
    CountryCode["BL"] = "BL";
    CountryCode["BM"] = "BM";
    CountryCode["BN"] = "BN";
    CountryCode["BO"] = "BO";
    CountryCode["BQ"] = "BQ";
    CountryCode["BR"] = "BR";
    CountryCode["BS"] = "BS";
    CountryCode["BT"] = "BT";
    CountryCode["BV"] = "BV";
    CountryCode["BW"] = "BW";
    CountryCode["BY"] = "BY";
    CountryCode["BZ"] = "BZ";
    CountryCode["CA"] = "CA";
    CountryCode["CC"] = "CC";
    CountryCode["CD"] = "CD";
    CountryCode["CF"] = "CF";
    CountryCode["CG"] = "CG";
    CountryCode["CH"] = "CH";
    CountryCode["CI"] = "CI";
    CountryCode["CK"] = "CK";
    CountryCode["CL"] = "CL";
    CountryCode["CM"] = "CM";
    CountryCode["CN"] = "CN";
    CountryCode["CO"] = "CO";
    CountryCode["CR"] = "CR";
    CountryCode["CU"] = "CU";
    CountryCode["CV"] = "CV";
    CountryCode["CW"] = "CW";
    CountryCode["CX"] = "CX";
    CountryCode["CY"] = "CY";
    CountryCode["CZ"] = "CZ";
    CountryCode["DE"] = "DE";
    CountryCode["DJ"] = "DJ";
    CountryCode["DK"] = "DK";
    CountryCode["DM"] = "DM";
    CountryCode["DO"] = "DO";
    CountryCode["DZ"] = "DZ";
    CountryCode["EC"] = "EC";
    CountryCode["EE"] = "EE";
    CountryCode["EG"] = "EG";
    CountryCode["EH"] = "EH";
    CountryCode["ER"] = "ER";
    CountryCode["ES"] = "ES";
    CountryCode["ET"] = "ET";
    CountryCode["FI"] = "FI";
    CountryCode["FJ"] = "FJ";
    CountryCode["FK"] = "FK";
    CountryCode["FM"] = "FM";
    CountryCode["FO"] = "FO";
    CountryCode["FR"] = "FR";
    CountryCode["GA"] = "GA";
    CountryCode["GB"] = "GB";
    CountryCode["GD"] = "GD";
    CountryCode["GE"] = "GE";
    CountryCode["GF"] = "GF";
    CountryCode["GG"] = "GG";
    CountryCode["GH"] = "GH";
    CountryCode["GI"] = "GI";
    CountryCode["GL"] = "GL";
    CountryCode["GM"] = "GM";
    CountryCode["GN"] = "GN";
    CountryCode["GP"] = "GP";
    CountryCode["GQ"] = "GQ";
    CountryCode["GR"] = "GR";
    CountryCode["GS"] = "GS";
    CountryCode["GT"] = "GT";
    CountryCode["GU"] = "GU";
    CountryCode["GW"] = "GW";
    CountryCode["GY"] = "GY";
    CountryCode["HK"] = "HK";
    CountryCode["HM"] = "HM";
    CountryCode["HN"] = "HN";
    CountryCode["HR"] = "HR";
    CountryCode["HT"] = "HT";
    CountryCode["HU"] = "HU";
    CountryCode["ID"] = "ID";
    CountryCode["IE"] = "IE";
    CountryCode["IL"] = "IL";
    CountryCode["IM"] = "IM";
    CountryCode["IN"] = "IN";
    CountryCode["IO"] = "IO";
    CountryCode["IQ"] = "IQ";
    CountryCode["IR"] = "IR";
    CountryCode["IS"] = "IS";
    CountryCode["IT"] = "IT";
    CountryCode["JE"] = "JE";
    CountryCode["JM"] = "JM";
    CountryCode["JO"] = "JO";
    CountryCode["JP"] = "JP";
    CountryCode["KE"] = "KE";
    CountryCode["KG"] = "KG";
    CountryCode["KH"] = "KH";
    CountryCode["KI"] = "KI";
    CountryCode["KM"] = "KM";
    CountryCode["KN"] = "KN";
    CountryCode["KP"] = "KP";
    CountryCode["KR"] = "KR";
    CountryCode["KW"] = "KW";
    CountryCode["KY"] = "KY";
    CountryCode["KZ"] = "KZ";
    CountryCode["LA"] = "LA";
    CountryCode["LB"] = "LB";
    CountryCode["LC"] = "LC";
    CountryCode["LI"] = "LI";
    CountryCode["LK"] = "LK";
    CountryCode["LR"] = "LR";
    CountryCode["LS"] = "LS";
    CountryCode["LT"] = "LT";
    CountryCode["LU"] = "LU";
    CountryCode["LV"] = "LV";
    CountryCode["LY"] = "LY";
    CountryCode["MA"] = "MA";
    CountryCode["MC"] = "MC";
    CountryCode["MD"] = "MD";
    CountryCode["ME"] = "ME";
    CountryCode["MF"] = "MF";
    CountryCode["MG"] = "MG";
    CountryCode["MH"] = "MH";
    CountryCode["MK"] = "MK";
    CountryCode["ML"] = "ML";
    CountryCode["MM"] = "MM";
    CountryCode["MN"] = "MN";
    CountryCode["MO"] = "MO";
    CountryCode["MP"] = "MP";
    CountryCode["MQ"] = "MQ";
    CountryCode["MR"] = "MR";
    CountryCode["MS"] = "MS";
    CountryCode["MT"] = "MT";
    CountryCode["MU"] = "MU";
    CountryCode["MV"] = "MV";
    CountryCode["MW"] = "MW";
    CountryCode["MX"] = "MX";
    CountryCode["MY"] = "MY";
    CountryCode["MZ"] = "MZ";
    CountryCode["NA"] = "NA";
    CountryCode["NC"] = "NC";
    CountryCode["NE"] = "NE";
    CountryCode["NF"] = "NF";
    CountryCode["NG"] = "NG";
    CountryCode["NI"] = "NI";
    CountryCode["NL"] = "NL";
    CountryCode["NO"] = "NO";
    CountryCode["NP"] = "NP";
    CountryCode["NR"] = "NR";
    CountryCode["NU"] = "NU";
    CountryCode["NZ"] = "NZ";
    CountryCode["OM"] = "OM";
    CountryCode["PA"] = "PA";
    CountryCode["PE"] = "PE";
    CountryCode["PF"] = "PF";
    CountryCode["PG"] = "PG";
    CountryCode["PH"] = "PH";
    CountryCode["PK"] = "PK";
    CountryCode["PL"] = "PL";
    CountryCode["PM"] = "PM";
    CountryCode["PN"] = "PN";
    CountryCode["PR"] = "PR";
    CountryCode["PS"] = "PS";
    CountryCode["PT"] = "PT";
    CountryCode["PW"] = "PW";
    CountryCode["PY"] = "PY";
    CountryCode["QA"] = "QA";
    CountryCode["RE"] = "RE";
    CountryCode["RO"] = "RO";
    CountryCode["RS"] = "RS";
    CountryCode["RU"] = "RU";
    CountryCode["RW"] = "RW";
    CountryCode["SA"] = "SA";
    CountryCode["SB"] = "SB";
    CountryCode["SC"] = "SC";
    CountryCode["SD"] = "SD";
    CountryCode["SE"] = "SE";
    CountryCode["SG"] = "SG";
    CountryCode["SH"] = "SH";
    CountryCode["SI"] = "SI";
    CountryCode["SJ"] = "SJ";
    CountryCode["SK"] = "SK";
    CountryCode["SL"] = "SL";
    CountryCode["SM"] = "SM";
    CountryCode["SN"] = "SN";
    CountryCode["SO"] = "SO";
    CountryCode["SR"] = "SR";
    CountryCode["ST"] = "ST";
    CountryCode["SV"] = "SV";
    CountryCode["SX"] = "SX";
    CountryCode["SY"] = "SY";
    CountryCode["SZ"] = "SZ";
    CountryCode["TC"] = "TC";
    CountryCode["TD"] = "TD";
    CountryCode["TF"] = "TF";
    CountryCode["TG"] = "TG";
    CountryCode["TH"] = "TH";
    CountryCode["TJ"] = "TJ";
    CountryCode["TK"] = "TK";
    CountryCode["TL"] = "TL";
    CountryCode["TM"] = "TM";
    CountryCode["TN"] = "TN";
    CountryCode["TO"] = "TO";
    CountryCode["TR"] = "TR";
    CountryCode["TT"] = "TT";
    CountryCode["TV"] = "TV";
    CountryCode["TW"] = "TW";
    CountryCode["TZ"] = "TZ";
    CountryCode["UA"] = "UA";
    CountryCode["UG"] = "UG";
    CountryCode["UM"] = "UM";
    CountryCode["US"] = "US";
    CountryCode["UY"] = "UY";
    CountryCode["UZ"] = "UZ";
    CountryCode["VA"] = "VA";
    CountryCode["VC"] = "VC";
    CountryCode["VE"] = "VE";
    CountryCode["VG"] = "VG";
    CountryCode["VI"] = "VI";
    CountryCode["VN"] = "VN";
    CountryCode["VU"] = "VU";
    CountryCode["WF"] = "WF";
    CountryCode["WS"] = "WS";
    CountryCode["YE"] = "YE";
    CountryCode["YT"] = "YT";
    CountryCode["ZA"] = "ZA";
    CountryCode["ZM"] = "ZM";
    CountryCode["ZW"] = "ZW";
})(CountryCode = exports.CountryCode || (exports.CountryCode = {}));
var CurrencyCode;
(function (CurrencyCode) {
    CurrencyCode["AED"] = "AED";
    CurrencyCode["AFN"] = "AFN";
    CurrencyCode["ALL"] = "ALL";
    CurrencyCode["AMD"] = "AMD";
    CurrencyCode["ANG"] = "ANG";
    CurrencyCode["AOA"] = "AOA";
    CurrencyCode["ARS"] = "ARS";
    CurrencyCode["AUD"] = "AUD";
    CurrencyCode["AWG"] = "AWG";
    CurrencyCode["AZN"] = "AZN";
    CurrencyCode["BAM"] = "BAM";
    CurrencyCode["BBD"] = "BBD";
    CurrencyCode["BDT"] = "BDT";
    CurrencyCode["BGN"] = "BGN";
    CurrencyCode["BHD"] = "BHD";
    CurrencyCode["BIF"] = "BIF";
    CurrencyCode["BMD"] = "BMD";
    CurrencyCode["BND"] = "BND";
    CurrencyCode["BOB"] = "BOB";
    CurrencyCode["BRL"] = "BRL";
    CurrencyCode["BSD"] = "BSD";
    CurrencyCode["BTN"] = "BTN";
    CurrencyCode["BWP"] = "BWP";
    CurrencyCode["BYR"] = "BYR";
    CurrencyCode["BZD"] = "BZD";
    CurrencyCode["CAD"] = "CAD";
    CurrencyCode["CDF"] = "CDF";
    CurrencyCode["CHF"] = "CHF";
    CurrencyCode["CLP"] = "CLP";
    CurrencyCode["CNY"] = "CNY";
    CurrencyCode["COP"] = "COP";
    CurrencyCode["CRC"] = "CRC";
    CurrencyCode["CUP"] = "CUP";
    CurrencyCode["CVE"] = "CVE";
    CurrencyCode["CZK"] = "CZK";
    CurrencyCode["DJF"] = "DJF";
    CurrencyCode["DKK"] = "DKK";
    CurrencyCode["DOP"] = "DOP";
    CurrencyCode["DZD"] = "DZD";
    CurrencyCode["EGP"] = "EGP";
    CurrencyCode["ERN"] = "ERN";
    CurrencyCode["ETB"] = "ETB";
    CurrencyCode["EUR"] = "EUR";
    CurrencyCode["FJD"] = "FJD";
    CurrencyCode["FKP"] = "FKP";
    CurrencyCode["GBP"] = "GBP";
    CurrencyCode["GEL"] = "GEL";
    CurrencyCode["GHS"] = "GHS";
    CurrencyCode["GIP"] = "GIP";
    CurrencyCode["GMD"] = "GMD";
    CurrencyCode["GNF"] = "GNF";
    CurrencyCode["GTQ"] = "GTQ";
    CurrencyCode["GYD"] = "GYD";
    CurrencyCode["HKD"] = "HKD";
    CurrencyCode["HNL"] = "HNL";
    CurrencyCode["HRK"] = "HRK";
    CurrencyCode["HTG"] = "HTG";
    CurrencyCode["HUF"] = "HUF";
    CurrencyCode["IDR"] = "IDR";
    CurrencyCode["ILS"] = "ILS";
    CurrencyCode["INR"] = "INR";
    CurrencyCode["IQD"] = "IQD";
    CurrencyCode["IRR"] = "IRR";
    CurrencyCode["ISK"] = "ISK";
    CurrencyCode["JMD"] = "JMD";
    CurrencyCode["JOD"] = "JOD";
    CurrencyCode["JPY"] = "JPY";
    CurrencyCode["KES"] = "KES";
    CurrencyCode["KGS"] = "KGS";
    CurrencyCode["KHR"] = "KHR";
    CurrencyCode["KMF"] = "KMF";
    CurrencyCode["KPW"] = "KPW";
    CurrencyCode["KRW"] = "KRW";
    CurrencyCode["KWD"] = "KWD";
    CurrencyCode["KYD"] = "KYD";
    CurrencyCode["KZT"] = "KZT";
    CurrencyCode["LAK"] = "LAK";
    CurrencyCode["LBP"] = "LBP";
    CurrencyCode["LKR"] = "LKR";
    CurrencyCode["LRD"] = "LRD";
    CurrencyCode["LSL"] = "LSL";
    CurrencyCode["LTL"] = "LTL";
    CurrencyCode["LYD"] = "LYD";
    CurrencyCode["MAD"] = "MAD";
    CurrencyCode["MDL"] = "MDL";
    CurrencyCode["MGA"] = "MGA";
    CurrencyCode["MKD"] = "MKD";
    CurrencyCode["MMK"] = "MMK";
    CurrencyCode["MNT"] = "MNT";
    CurrencyCode["MOP"] = "MOP";
    CurrencyCode["MRO"] = "MRO";
    CurrencyCode["MUR"] = "MUR";
    CurrencyCode["MVR"] = "MVR";
    CurrencyCode["MWK"] = "MWK";
    CurrencyCode["MXN"] = "MXN";
    CurrencyCode["MYR"] = "MYR";
    CurrencyCode["MZN"] = "MZN";
    CurrencyCode["NAD"] = "NAD";
    CurrencyCode["NGN"] = "NGN";
    CurrencyCode["NIO"] = "NIO";
    CurrencyCode["NOK"] = "NOK";
    CurrencyCode["NPR"] = "NPR";
    CurrencyCode["NZD"] = "NZD";
    CurrencyCode["OMR"] = "OMR";
    CurrencyCode["PAB"] = "PAB";
    CurrencyCode["PEN"] = "PEN";
    CurrencyCode["PGK"] = "PGK";
    CurrencyCode["PHP"] = "PHP";
    CurrencyCode["PKR"] = "PKR";
    CurrencyCode["PLN"] = "PLN";
    CurrencyCode["PYG"] = "PYG";
    CurrencyCode["QAR"] = "QAR";
    CurrencyCode["RON"] = "RON";
    CurrencyCode["RSD"] = "RSD";
    CurrencyCode["RUB"] = "RUB";
    CurrencyCode["RWF"] = "RWF";
    CurrencyCode["SAR"] = "SAR";
    CurrencyCode["SBD"] = "SBD";
    CurrencyCode["SCR"] = "SCR";
    CurrencyCode["SDG"] = "SDG";
    CurrencyCode["SEK"] = "SEK";
    CurrencyCode["SGD"] = "SGD";
    CurrencyCode["SHP"] = "SHP";
    CurrencyCode["SLL"] = "SLL";
    CurrencyCode["SOS"] = "SOS";
    CurrencyCode["SRD"] = "SRD";
    CurrencyCode["STD"] = "STD";
    CurrencyCode["SYP"] = "SYP";
    CurrencyCode["SZL"] = "SZL";
    CurrencyCode["THB"] = "THB";
    CurrencyCode["TJS"] = "TJS";
    CurrencyCode["TMT"] = "TMT";
    CurrencyCode["TND"] = "TND";
    CurrencyCode["TOP"] = "TOP";
    CurrencyCode["TRY"] = "TRY";
    CurrencyCode["TTD"] = "TTD";
    CurrencyCode["TWD"] = "TWD";
    CurrencyCode["TZS"] = "TZS";
    CurrencyCode["UAH"] = "UAH";
    CurrencyCode["UGX"] = "UGX";
    CurrencyCode["USD"] = "USD";
    CurrencyCode["UYU"] = "UYU";
    CurrencyCode["UZS"] = "UZS";
    CurrencyCode["VEF"] = "VEF";
    CurrencyCode["VND"] = "VND";
    CurrencyCode["VUV"] = "VUV";
    CurrencyCode["WST"] = "WST";
    CurrencyCode["XAF"] = "XAF";
    CurrencyCode["XCD"] = "XCD";
    CurrencyCode["XOF"] = "XOF";
    CurrencyCode["XPF"] = "XPF";
    CurrencyCode["YER"] = "YER";
    CurrencyCode["ZAR"] = "ZAR";
    CurrencyCode["ZMW"] = "ZMW";
    CurrencyCode["ZWL"] = "ZWL";
})(CurrencyCode = exports.CurrencyCode || (exports.CurrencyCode = {}));
var Condition;
(function (Condition) {
    Condition["NEW"] = "NEW";
    Condition["LIKE_NEW"] = "LIKE_NEW";
    Condition["NEW_OTHER"] = "NEW_OTHER";
    Condition["NEW_WITH_DEFECTS"] = "NEW_WITH_DEFECTS";
    Condition["MANUFACTURER_REFURBISHED"] = "MANUFACTURER_REFURBISHED";
    Condition["SELLER_REFURBISHED"] = "SELLER_REFURBISHED";
    Condition["USED_EXCELLENT"] = "USED_EXCELLENT";
    Condition["USED_VERY_GOOD"] = "USED_VERY_GOOD";
    Condition["USED_GOOD"] = "USED_GOOD";
    Condition["USED_ACCEPTABLE"] = "USED_ACCEPTABLE";
    Condition["FOR_PARTS_OR_NOT_WORKING"] = "FOR_PARTS_OR_NOT_WORKING";
})(Condition = exports.Condition || (exports.Condition = {}));
var Locale;
(function (Locale) {
    Locale["en_US"] = "en_US";
    Locale["en_CA"] = "en_CA";
    Locale["fr_CA"] = "fr_CA";
    Locale["en_GB"] = "en_GB";
    Locale["en_AU"] = "en_AU";
    Locale["en_IN"] = "en_IN";
    Locale["de_AT"] = "de_AT";
    Locale["fr_BE"] = "fr_BE";
    Locale["fr_FR"] = "fr_FR";
    Locale["de_DE"] = "de_DE";
    Locale["it_IT"] = "it_IT";
    Locale["nl_BE"] = "nl_BE";
    Locale["nl_NL"] = "nl_NL";
    Locale["es_ES"] = "es_ES";
    Locale["de_CH"] = "de_CH";
    Locale["fi_FI"] = "fi_FI";
    Locale["zh_HK"] = "zh_HK";
    Locale["hu_HU"] = "hu_HU";
    Locale["en_PH"] = "en_PH";
    Locale["pl_PL"] = "pl_PL";
    Locale["pt_PT"] = "pt_PT";
    Locale["ru_RU"] = "ru_RU";
    Locale["en_SG"] = "en_SG";
    Locale["en_IE"] = "en_IE";
    Locale["en_MY"] = "en_MY";
})(Locale = exports.Locale || (exports.Locale = {}));
var ContentLanguage;
(function (ContentLanguage) {
    ContentLanguage["de_AT"] = "de-AT";
    ContentLanguage["de_CH"] = "de-CH";
    ContentLanguage["de_DE"] = "de-DE";
    ContentLanguage["en_AU"] = "en-AU";
    ContentLanguage["en_CA"] = "en-CA";
    ContentLanguage["en_GB"] = "en-GB";
    ContentLanguage["en_IE"] = "en-IE";
    ContentLanguage["en_PH"] = "en-PH";
    ContentLanguage["en_US"] = "en-US";
    ContentLanguage["es_ES"] = "es-ES";
    ContentLanguage["fr_BE"] = "fr-BE";
    ContentLanguage["fr_CA"] = "fr-CA";
    ContentLanguage["fr_FR"] = "fr-FR";
    ContentLanguage["it_IT"] = "it-IT";
    ContentLanguage["nl_BE"] = "nl-BE";
    ContentLanguage["nl_NL"] = "nl-NL";
    ContentLanguage["pl_PL"] = "pl-PL";
    ContentLanguage["th_TH"] = "th-TH";
    ContentLanguage["zh_HK"] = "zh-HK";
    ContentLanguage["zh_TW"] = "zh-TW";
})(ContentLanguage = exports.ContentLanguage || (exports.ContentLanguage = {}));
var Marketplace;
(function (Marketplace) {
    Marketplace["EBAY_US"] = "EBAY_US";
    Marketplace["EBAY_MOTORS"] = "EBAY_MOTORS";
    Marketplace["EBAY_CA"] = "EBAY_CA";
    Marketplace["EBAY_GB"] = "EBAY_GB";
    Marketplace["EBAY_AU"] = "EBAY_AU";
    Marketplace["EBAY_AT"] = "EBAY_AT";
    Marketplace["EBAY_BE"] = "EBAY_BE";
    Marketplace["EBAY_FR"] = "EBAY_FR";
    Marketplace["EBAY_DE"] = "EBAY_DE";
    Marketplace["EBAY_IT"] = "EBAY_IT";
    Marketplace["EBAY_NL"] = "EBAY_NL";
    Marketplace["EBAY_ES"] = "EBAY_ES";
    Marketplace["EBAY_CH"] = "EBAY_CH";
    Marketplace["EBAY_TW"] = "EBAY_TW";
    Marketplace["EBAY_CZ"] = "EBAY_CZ";
    Marketplace["EBAY_DK"] = "EBAY_DK";
    Marketplace["EBAY_FI"] = "EBAY_FI";
    Marketplace["EBAY_GR"] = "EBAY_GR";
    Marketplace["EBAY_HK"] = "EBAY_HK";
    Marketplace["EBAY_HU"] = "EBAY_HU";
    Marketplace["EBAY_IN"] = "EBAY_IN";
    Marketplace["EBAY_ID"] = "EBAY_ID";
    Marketplace["EBAY_IE"] = "EBAY_IE";
    Marketplace["EBAY_IL"] = "EBAY_IL";
    Marketplace["EBAY_MY"] = "EBAY_MY";
    Marketplace["EBAY_NZ"] = "EBAY_NZ";
    Marketplace["EBAY_NO"] = "EBAY_NO";
    Marketplace["EBAY_PH"] = "EBAY_PH";
    Marketplace["EBAY_PL"] = "EBAY_PL";
    Marketplace["EBAY_PT"] = "EBAY_PT";
    Marketplace["EBAY_PR"] = "EBAY_PR";
    Marketplace["EBAY_RU"] = "EBAY_RU";
    Marketplace["EBAY_SG"] = "EBAY_SG";
    Marketplace["EBAY_ZA"] = "EBAY_ZA";
    Marketplace["EBAY_SE"] = "EBAY_SE";
    Marketplace["EBAY_TH"] = "EBAY_TH";
    Marketplace["EBAY_VN"] = "EBAY_VN";
    Marketplace["EBAY_CN"] = "EBAY_CN";
    Marketplace["EBAY_PE"] = "EBAY_PE";
    Marketplace["EBAY_JP"] = "EBAY_JP";
})(Marketplace = exports.Marketplace || (exports.Marketplace = {}));
var FormatType;
(function (FormatType) {
    FormatType["AUCTION"] = "AUCTION";
    FormatType["FIXED_PRICE"] = "FIXED_PRICE";
})(FormatType = exports.FormatType || (exports.FormatType = {}));
var Metric;
(function (Metric) {
    Metric[Metric["CLICK_THROUGH_RATE"] = 0] = "CLICK_THROUGH_RATE";
    Metric[Metric["LISTING_IMPRESSION_STORE"] = 1] = "LISTING_IMPRESSION_STORE";
    Metric[Metric["LISTING_IMPRESSION_TOTAL"] = 2] = "LISTING_IMPRESSION_TOTAL";
    Metric[Metric["LISTING_VIEWS_SOURCE_DIRECT"] = 3] = "LISTING_VIEWS_SOURCE_DIRECT";
    Metric[Metric["LISTING_VIEWS_SOURCE_OFF_EBAY"] = 4] = "LISTING_VIEWS_SOURCE_OFF_EBAY";
    Metric[Metric["LISTING_VIEWS_SOURCE_OTHER_EBAY"] = 5] = "LISTING_VIEWS_SOURCE_OTHER_EBAY";
    Metric[Metric["LISTING_VIEWS_SOURCE_SEARCH_RESULTS_PAGE"] = 6] = "LISTING_VIEWS_SOURCE_SEARCH_RESULTS_PAGE";
    Metric[Metric["LISTING_VIEWS_SOURCE_STORE"] = 7] = "LISTING_VIEWS_SOURCE_STORE";
    Metric[Metric["LISTING_VIEWS_TOTAL"] = 8] = "LISTING_VIEWS_TOTAL";
    Metric[Metric["SALES_CONVERSION_RATE"] = 9] = "SALES_CONVERSION_RATE";
    Metric[Metric["TRANSACTION"] = 10] = "TRANSACTION";
})(Metric = exports.Metric || (exports.Metric = {}));
var ReturnMethod;
(function (ReturnMethod) {
    ReturnMethod["EXCHANGE"] = "EXCHANGE";
    ReturnMethod["REPLACEMENT"] = "REPLACEMENT";
})(ReturnMethod = exports.ReturnMethod || (exports.ReturnMethod = {}));
var ReturnShippingCostPayer;
(function (ReturnShippingCostPayer) {
    ReturnShippingCostPayer["BUYER"] = "BUYER";
    ReturnShippingCostPayer["SELLER"] = "SELLER";
})(ReturnShippingCostPayer = exports.ReturnShippingCostPayer || (exports.ReturnShippingCostPayer = {}));
var RegionType;
(function (RegionType) {
    RegionType["COUNTRY"] = "COUNTRY";
    RegionType["COUNTRY_REGION"] = "COUNTRY_REGION";
    RegionType["STATE_OR_PROVINCE"] = "STATE_OR_PROVINCE";
    RegionType["WORLD_REGION"] = "WORLD_REGION";
    RegionType["WORLDWIDE"] = "WORLDWIDE";
})(RegionType = exports.RegionType || (exports.RegionType = {}));
var ReasonForRefund;
(function (ReasonForRefund) {
    ReasonForRefund["BUYER_CANCEL"] = "BUYER_CANCEL";
    ReasonForRefund["SELLER_CANCEL"] = "SELLER_CANCEL";
    ReasonForRefund["ITEM_NOT_RECEIVED"] = "ITEM_NOT_RECEIVED";
    ReasonForRefund["BUYER_RETURN"] = "BUYER_RETURN";
    ReasonForRefund["ITEM_NOT_AS_DESCRIBED"] = "ITEM_NOT_AS_DESCRIBED";
    ReasonForRefund["OTHER_ADJUSTMENT"] = "OTHER_ADJUSTMENT";
    ReasonForRefund["SHIPPING_DISCOUNT"] = "SHIPPING_DISCOUNT";
})(ReasonForRefund = exports.ReasonForRefund || (exports.ReasonForRefund = {}));
var CancelReason;
(function (CancelReason) {
    CancelReason["ADDRESS_ISSUES"] = "ADDRESS_ISSUES";
    CancelReason["BUYER_ASKED_CANCEL"] = "BUYER_ASKED_CANCEL";
    CancelReason["BUYER_CANCEL_OR_ADDRESS_ISSUE"] = "BUYER_CANCEL_OR_ADDRESS_ISSUE";
    CancelReason["FOUND_CHEAPER_PRICE"] = "FOUND_CHEAPER_PRICE";
    CancelReason["ORDER_MISTAKE"] = "ORDER_MISTAKE";
    CancelReason["ORDER_UNPAID"] = "ORDER_UNPAID";
    CancelReason["OTHER"] = "OTHER";
    CancelReason["OUT_OF_STOCK_OR_CANNOT_FULFILL"] = "OUT_OF_STOCK_OR_CANNOT_FULFILL";
    CancelReason["PRICE_TOO_HIGH"] = "PRICE_TOO_HIGH";
    CancelReason["UNKNOWN"] = "UNKNOWN";
    CancelReason["WONT_ARRIVE_IN_TIME"] = "WONT_ARRIVE_IN_TIME";
    CancelReason["WRONG_PAYMENT_METHOD"] = "WRONG_PAYMENT_METHOD";
    CancelReason["WRONG_SHIPPING_ADDRESS"] = "WRONG_SHIPPING_ADDRESS";
    CancelReason["WRONG_SHIPPING_METHOD"] = "WRONG_SHIPPING_METHOD";
})(CancelReason = exports.CancelReason || (exports.CancelReason = {}));
var LengthUnitOfMeasure;
(function (LengthUnitOfMeasure) {
    LengthUnitOfMeasure["INCH"] = "INCH";
    LengthUnitOfMeasure["FEET"] = "FEET";
    LengthUnitOfMeasure["CENTIMETER"] = "CENTIMETER";
    LengthUnitOfMeasure["METER"] = "METER";
})(LengthUnitOfMeasure = exports.LengthUnitOfMeasure || (exports.LengthUnitOfMeasure = {}));
var WeightUnitOfMeasure;
(function (WeightUnitOfMeasure) {
    WeightUnitOfMeasure["POUND"] = "POUND";
    WeightUnitOfMeasure["KILOGRAM"] = "KILOGRAM";
    WeightUnitOfMeasure["OUNCE"] = "OUNCE";
    WeightUnitOfMeasure["GRAM"] = "GRAM";
})(WeightUnitOfMeasure = exports.WeightUnitOfMeasure || (exports.WeightUnitOfMeasure = {}));
var PackageType;
(function (PackageType) {
    PackageType["LETTER"] = "LETTER";
    PackageType["BULKY_GOODS"] = "BULKY_GOODS";
    PackageType["CARAVAN"] = "CARAVAN";
    PackageType["CARS"] = "CARS";
    PackageType["EUROPALLET"] = "EUROPALLET";
    PackageType["EXPANDABLE_TOUGH_BAGS"] = "EXPANDABLE_TOUGH_BAGS";
    PackageType["EXTRA_LARGE_PACK"] = "EXTRA_LARGE_PACK";
    PackageType["FURNITURE"] = "FURNITURE";
    PackageType["INDUSTRY_VEHICLES"] = "INDUSTRY_VEHICLES";
    PackageType["LARGE_CANADA_POSTBOX"] = "LARGE_CANADA_POSTBOX";
    PackageType["LARGE_CANADA_POST_BUBBLE_MAILER"] = "LARGE_CANADA_POST_BUBBLE_MAILER";
    PackageType["LARGE_ENVELOPE"] = "LARGE_ENVELOPE";
    PackageType["MAILING_BOX"] = "MAILING_BOX";
    PackageType["MEDIUM_CANADA_POST_BOX"] = "MEDIUM_CANADA_POST_BOX";
    PackageType["MEDIUM_CANADA_POST_BUBBLE_MAILER"] = "MEDIUM_CANADA_POST_BUBBLE_MAILER";
    PackageType["MOTORBIKES"] = "MOTORBIKES";
    PackageType["ONE_WAY_PALLET"] = "ONE_WAY_PALLET";
    PackageType["PACKAGE_THICK_ENVELOPE"] = "PACKAGE_THICK_ENVELOPE";
    PackageType["PADDED_BAGS"] = "PADDED_BAGS";
    PackageType["PARCEL_OR_PADDED_ENVELOPE"] = "PARCEL_OR_PADDED_ENVELOPE";
    PackageType["ROLL"] = "ROLL";
    PackageType["SMALL_CANADA_POST_BOX"] = "SMALL_CANADA_POST_BOX";
    PackageType["SMALL_CANADA_POST_BUBBLE_MAILER"] = "SMALL_CANADA_POST_BUBBLE_MAILER";
    PackageType["TOUGH_BAGS"] = "TOUGH_BAGS";
    PackageType["UPS_LETTER"] = "UPS_LETTER";
    PackageType["USPS_FLAT_RATE_ENVELOPE"] = "USPS_FLAT_RATE_ENVELOPE";
    PackageType["USPS_LARGE_PACK"] = "USPS_LARGE_PACK";
    PackageType["VERY_LARGE_PACK"] = "VERY_LARGE_PACK";
    PackageType["WINE_PAK"] = "WINE_PAK";
})(PackageType = exports.PackageType || (exports.PackageType = {}));
//# sourceMappingURL=restfulEnums.js.map